import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FatherService } from './father.service';
import { ProcessRequestDemoPayload, ProcessRequestDemoResponse } from '../interfaces/request-demo.interface';
import {HttpClient} from "@angular/common/http";
import {LocalstorageService} from "./localstorage.service";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DemoService extends FatherService {

  showDemo$ = new Subject();
  countDemoRequested$ = new BehaviorSubject(0);

  constructor(
    public dialog: MatDialog,
    httpClient: HttpClient,
    localstorageService: LocalstorageService
  ) {
    super(httpClient, localstorageService);
  }

  getRequestDemoList() {
    return this.get('/api-license/request-demo');
  }

  processRequestDemo(payload: ProcessRequestDemoPayload): Observable<ProcessRequestDemoResponse> {
    return this.post('/api-license/request-demo/process', payload) as Observable<ProcessRequestDemoResponse>;
  }
}
